import { faSitemap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function stopEnumeration() {
    return (
        <div data-cy="historic-controller-stopEnum">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.stopEnumeration" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faSitemap} style={{ color: 'red' }} size="lg" />
            </Whisper>
        </div>
    );
}
